import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { ApiServiceService } from '../../../Services/api-service.service';
import alertify from 'alertifyjs';

@Component({
  selector: 'app-user-bills',
  templateUrl: './user-bills.component.html',
  styleUrls: ['./user-bills.component.css'],
  providers: [CurrencyPipe],
})
export class UserBillsComponent implements OnInit {
  searchForm: FormGroup;
  details: any[] = [];
  isEmpty = false;
  isSearching = false;
  searchInstruction = true;
  page = 0;
  num = 0;
  currentPage = 1;
  count = 0;
  pageSize = 10;
  showSearch = false;

  readonly assessmentTypes = [
    { value: 'tax', label: 'Tax' },
    { value: 'non_tax', label: 'Non Tax' },
    { value: 'backduty', label: 'Back Duty' },
    { value: 'edl', label: 'Economic Development Levy' },
    { value: 'wht', label: 'Withholding Tax' },
  ];

  constructor(
    private readonly fb: FormBuilder,
    private readonly apiService: ApiServiceService,
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      asin: ['', Validators.required],
      assessmentType: [''],
    });
  }

  toggleSearch(): void {
    this.showSearch = !this.showSearch;
  }

  search(): void {
    this.searchForm.markAllAsTouched();
    if (!this.searchForm.valid) return;

    this.details = [];
    this.isEmpty = false;
    this.isSearching = true;
    this.searchInstruction = false;

    const payload = {
      asin: this.searchForm.get('asin').value,
      assessmentType: this.searchForm.get('assessmentType').value || '',
      offset: '0',
    };

    this.apiService.post('/assessments/search/user-bills', payload).subscribe({
      next: (response) => {
        this.isSearching = false;
        const data = response?.data;
        if (!data) {
          this.isEmpty = true;
          return;
        }

        const selectedType = this.searchForm.get('assessmentType').value;
        if (selectedType) {
          // Backend returns a flat array when assessmentType is specified
          this.details = Array.isArray(data) ? data : [];
        } else {
          // Backend returns a grouped object when no type is specified
          this.details = [
            ...(data.tax || []),
            ...(data.wht || []),
            ...(data.non_tax || []),
            ...(data.edl || []),
            ...(data.backduty || []),
          ];
        }

        this.count = this.details.length;
        this.isEmpty = this.details.length === 0;
      },
      error: () => {
        this.isSearching = false;
        this.isEmpty = true;
        alertify.set('notifier', 'position', 'top-center');
        alertify.error('Error performing this operation');
      },
    });
  }

  callDb(event: number): void {
    this.currentPage = event;
    this.page = event - 1;
    this.num = this.page * this.pageSize;
  }

  get pagedDetails(): any[] {
    return this.details.slice(this.page * this.pageSize, (this.page + 1) * this.pageSize);
  }

  resetForm(): void {
    this.searchForm.reset({ asin: '', assessmentType: '' });
    this.details = [];
    this.isEmpty = false;
    this.searchInstruction = true;
    this.currentPage = 1;
    this.page = 0;
    this.num = 0;
  }
}
